/**
 * This dispatches an action when a default variant option changes.
 *
 * This needs to be extended to add the chooserId when we have variants so we can map to the pconf.
 *
 * Usage:
 * data-sw-variant-option-default=<chooserId>
 * 
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

require([
  'js/lib/actions/ProductEditModel/actionCreators'
], function(actionCreators) {

  $('body').on('click', '[data-sw-variant-option-default]', function() {
  	var defaultData = {};
  	$('[data-sw-variant-option-default]:checked').each(function() {
  	  var $selectedDefault = $(this);
  	  var attributeName = $selectedDefault.attr('name');

  	  defaultData[attributeName] = $selectedDefault.val();
  	});

  	sw.dispatch(actionCreators.pconfDefaultChanged(defaultData));
  });
  
});
